export default __webpack_public_path__ + "static/media/telegram.4e08bec4.svg";